import React, { useEffect, useRef, useState } from 'react';
import BEMHelper from '@ynap/bem-helper';
import Overlay, { StopPropagation } from '@ynap/overlay';
import { SizeSelect } from '@ynap/product-details-page';
import { useProductDetails } from '@ynap/api-hooks';
import Spinner from '@ynap/spinner';
import PropTypes from 'prop-types';

const bem = new BEMHelper('SizeSelectModal');

export const SizeSelectModal = ({ product, closeModal, messages, cart, includeCartWithAddToBag, setSizeSkuModal }) => {
    const [productColour, setProductColour] = useState({});
    const sizeSelectRef = useRef(null);
    const productDetails = useProductDetails({
        partNumber: product.partNumber,
    });
    const { sKUs, price } = productColour;

    // Duplicate sku filtering https://git.yoox.net/projects/yos/repos/yos/browse/packages/state/product-details-state/src/selectors/getSelectedProduct.js?at=3f21483c4e44ef2bee81bf6b73f54115b574c1b9#350
    const skus = sKUs?.filter?.((sku) => sku.displayable && !sku.banned) || [];

    useEffect(() => {
        if (!productDetails?.isProductDetailsLoading && productDetails?.details?.productColours) {
            setProductColour(productDetails.details.productColours[0]);
        }
    }, [productDetails]);

    const changeSelectedSku = async (sizeSku) => {
        if (sizeSku.buyable) {
            setSizeSkuModal(sizeSku.partNumber);
            cart.addToCart(sizeSku.partNumber, {
                setActionNotificationOnError: false,
                addToCartLoading: cart.addToCartLoading,
                includeShoppingCart: includeCartWithAddToBag,
            }).finally(closeModal);
        }
    };

    const isLoading = Boolean(productDetails?.isProductDetailsLoading || cart.addToCartLoading);

    useEffect(() => {
        if (skus?.length === 1) {
            setSizeSkuModal(skus[0]);
            cart.addToCart(skus[0]).finally(closeModal);
        }
    }, [skus?.length]);

    if (skus?.length > 1) {
        return (
            <StopPropagation>
                <Overlay
                    className={{ container: bem('overlaySize') }}
                    onClose={closeModal}
                    type="success"
                    title={messages.sizes.initialValue()}
                    reducedModePosition={'reducedModePosition'}
                >
                    <Spinner loading={isLoading}>
                        <SizeSelect
                            sizeSelectRef={sizeSelectRef}
                            skus={skus}
                            displayLabel={false}
                            price={price}
                            messages={messages}
                            changeSelectedSku={(sizeSku) => {
                                changeSelectedSku(sizeSku);
                            }}
                            sizeGridFeatureToggle={true}
                            alwaysGrid={true}
                            disableOneSizeLeft={true}
                            className={bem('sizeSelect')}
                            headingClassName={bem('sizeSelectHeading')}
                            disableNotification={true}
                        />
                    </Spinner>
                </Overlay>
            </StopPropagation>
        );
    }

    return null;
};

SizeSelectModal.propTypes = {
    product: PropTypes.object,
    closeModal: PropTypes.func,
    messages: PropTypes.object,
    cart: PropTypes.object,
    includeCartWithAddToBag: PropTypes.bool,
    setSizeSkuModal: PropTypes.func,
};

export default SizeSelectModal;
